var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User Icon - White"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.6152 13.8092L18.6154 13.8096C19.5349 15.4529 20.3974 17.3225 21.0289 19.1431C21.6628 20.9705 22.0526 22.7167 22.0526 24.1229C22.0526 25.6291 21.7278 26.6741 21.2059 27.4124C20.6856 28.1483 19.932 28.6325 18.9726 28.9485C18.0061 29.2669 16.8532 29.4068 15.5704 29.4638C14.6023 29.5067 13.5852 29.5019 12.5366 29.4969C12.1942 29.4953 11.8484 29.4936 11.4999 29.4936C11.1514 29.4936 10.8056 29.4953 10.4632 29.4969C9.41461 29.5019 8.39757 29.5067 7.4294 29.4638C6.14665 29.4068 4.99376 29.2669 4.02718 28.9485C3.06785 28.6325 2.3142 28.1483 1.79395 27.4124C1.27201 26.6741 0.947266 25.6291 0.947266 24.1229C0.947266 22.7167 1.33707 20.9705 1.9709 19.1431C2.60238 17.3225 3.46492 15.4529 4.38441 13.8096L4.38467 13.8092C4.77576 13.1085 5.59941 12.9317 6.21833 13.3718L6.21866 13.3721C7.7296 14.4448 9.54603 15.0724 11.4999 15.0724C13.4538 15.0724 15.2702 14.4448 16.7812 13.3721L16.7815 13.3718C17.4004 12.9317 18.2241 13.1085 18.6152 13.8092Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.3152 6.3158C17.3152 9.52777 14.7114 12.1316 11.4994 12.1316C8.28741 12.1316 5.68359 9.52777 5.68359 6.3158C5.68359 3.10382 8.28741 0.5 11.4994 0.5C14.7114 0.5 17.3152 3.10382 17.3152 6.3158Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 253"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.374 8.45549L19.6886 19.141L15.127 21.1827C14.707 21.3707 14.2776 20.9395 14.4671 20.5203L16.5223 15.9761L27.2084 5.28991C28.0826 4.41576 29.4999 4.41576 30.374 5.28991C31.2482 6.16406 31.2482 7.58134 30.374 8.45549Z",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.374 8.45549L19.6886 19.141L15.127 21.1827C14.707 21.3707 14.2776 20.9395 14.4671 20.5203L16.5223 15.9761L27.2084 5.28991C28.0826 4.41576 29.4999 4.41576 30.374 5.28991C31.2482 6.16406 31.2482 7.58134 30.374 8.45549Z",
    stroke: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.2188737804d9c5a47adf5324726d1e36.svg";
export { ForwardRef as ReactComponent };